// extracted by mini-css-extract-plugin
export default {"Pfourth":"Pfourth_Pfourth__nIqkB","box":"Pfourth_box__+RrAl","leftImg":"Pfourth_leftImg__1uHgL","rightImg":"Pfourth_rightImg__Wpb89","content":"Pfourth_content__ZBI6N"};